import { z } from 'zod';

import { EquipmentStatusSchema } from '@/features/equipment/-constants';
import { EquipmentTableColumns } from '@/features/equipment/-query/selector';

export const EquipmentItemDetailSearchSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(EquipmentTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('asc'),
  status: EquipmentStatusSchema.default('ALL'),
  freeText: z.string().optional(),
});
